import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Dialog from 'rc-dialog';
import OutlinedClose from "acud-icon/es/icons/OutlinedClose";
import { ConfigContext } from '../config-provider';
import Button from '../button';
import { canUseDocElement } from '../_util/styleChecker';
import { getTransitionName } from '../_util/motion';
import classNames from 'classnames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { getModalLocale } from './locale';
var mousePosition;
// 100ms 内发生过点击事件，则从点击位置动画展示
var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  setTimeout(function () {
    mousePosition = null;
  }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
  document.documentElement.addEventListener('click', getClickPosition, true);
}
// type SizeType = 'small' | 'normal' | 'large' | 'extraLarge';
var SizeType;
(function (SizeType) {
  SizeType["small"] = "sm";
  SizeType["normal"] = "md";
  SizeType["large"] = "lg";
  SizeType["extraLarge"] = "xl";
})(SizeType || (SizeType = {}));
;
var Modal = function Modal(props) {
  var _React$useContext = React.useContext(ConfigContext),
    getPopupContainer = _React$useContext.getPopupContainer,
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('modal', props.prefixCls);
  var rootPrefixCls = getPrefixCls();
  var handleCancel = function handleCancel(e) {
    var onCancel = props.onCancel;
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
  };
  var handleOk = function handleOk(e) {
    var onOk = props.onOk;
    onOk === null || onOk === void 0 ? void 0 : onOk(e);
  };
  var renderFooter = function renderFooter(locale) {
    var okText = props.okText,
      cancelText = props.cancelText,
      confirmLoading = props.confirmLoading,
      okButtonProps = props.okButtonProps,
      cancelButtonProps = props.cancelButtonProps;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
      onClick: handleCancel,
      type: "default"
    }, cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(Button, _extends({
      onClick: handleOk,
      loading: confirmLoading,
      type: "primary"
    }, okButtonProps), okText || locale.okText));
  };
  var defaultFooter = /*#__PURE__*/React.createElement(LocaleReceiver, {
    componentName: "Modal",
    defaultLocale: getModalLocale()
  }, renderFooter);
  var visible = props.visible,
    size = props.size,
    className = props.className,
    footer = props.footer,
    getContainer = props.getContainer,
    closeIcon = props.closeIcon;
  var dialogFooter = footer === undefined ? defaultFooter : footer;
  var dialogGetContainer = getContainer !== null && getContainer !== void 0 ? getContainer : getPopupContainer;
  var dialogCloseIcon = /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, closeIcon === undefined ? /*#__PURE__*/React.createElement(OutlinedClose, {
    className: "".concat(prefixCls, "-close-icon")
  }) : closeIcon);
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, props, {
    // TODO: Ignore this type error for now, otherwise need to upgrade rc-dialog.
    width: props.width,
    className: classNames(className, "".concat(prefixCls, "-").concat(SizeType[size])),
    getContainer: dialogGetContainer,
    prefixCls: prefixCls,
    visible: visible,
    footer: dialogFooter,
    mousePosition: mousePosition,
    onClose: handleCancel,
    closeIcon: dialogCloseIcon,
    transitionName: getTransitionName(rootPrefixCls, 'fade'),
    maskTransitionName: getTransitionName(rootPrefixCls, 'fade')
  }));
};
Modal.defaultProps = {
  size: 'small',
  visible: false,
  confirmLoading: false,
  maskClosable: false
};
export default Modal;